import { render, staticRenderFns } from "./input-number-with-popover-upsell.vue?vue&type=template&id=6b7ae226"
import script from "./input-number-with-popover-upsell.vue?vue&type=script&lang=js"
export * from "./input-number-with-popover-upsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports